import { Box, CircularProgress, Typography } from '@mui/material';

const InProgress = () => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            textAlign="center" // for the text
            flexDirection="column" // this is for the text
        >
            <CircularProgress />
            <Typography
                variant="body1"
                color="textSecondary"
                style={{ marginTop: 16 }}
            >
                Wenn dies das erste Laden ist, warten Sie bitte darauf 20
                Sekunden ...
            </Typography>
        </Box>
    );
};

export default InProgress;
